module.exports = __webpack_public_path__ + "static/media/galeryFloating4.eb0dcf20.jpg";